var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"light","content":_vm.content}},[_c('div',{class:_vm.iconClass},[_c('icon',{attrs:{"icon":_vm.superIcon}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }